import React, { useEffect } from "react";
import Header from "./Headers";
import Styles from '../assets/css/Header.module.css'
import AlexxcansolsHeaders from "./AlexxcansolsHeaders";
import PartnerHeaders from "./PartnerHeaders";
const Layout = props => {
  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <Header styles={Styles} />
        <br />
        <br />
        <div className="main-content">{props.children}</div>
      </div>
      {/* {showRightSidebar ? <RightSidebar /> : null} */}
    </React.Fragment>
  );
};

// AlexxcansolsLayout Component
const AlexxcansolsLayout = (props) => {
  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <AlexxcansolsHeaders styles={Styles} />
        <br />
        <br />
        <div className="main-content">{props.children}</div>
      </div>
      {/* {showRightSidebar ? <RightSidebar /> : null} */}
    </React.Fragment>
  );
};
const PartnerLayout = (props) => {
  return (
    <React.Fragment>
      <div id="layout-wrapper">
        <PartnerHeaders styles={Styles} />
        <br />
        <br />
        <div className="main-content">{props.children}</div>
      </div>
      {/* {showRightSidebar ? <RightSidebar /> : null} */}
    </React.Fragment>
  );
};

export { Layout, AlexxcansolsLayout, PartnerLayout };

